export default {"src":"/_next/static/image/public/images/ic_tick_orange.c7ee3384fbb70912298f26794fb8f8e5.svg","height":12,"width":15};